import { TitleBarProps } from "./types/titleBarProps";
import './titleBar.scss';
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { stylizationVerticalAlign } from "../../../../components/shared/stylization";
import { ReactComponent as accountCircle } from '../../../../icons/account_circle.svg';
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { SaveProtocolProps } from "../../../../services/protocolFormService/types/protocolFormServiceProps";
import { notifyError, notifySuccess, notifyWarn } from "../../../../components/snackbar/snackbar";
import { saveProtocol } from "../../../../services/protocolFormService/protocolFormService";
import { useContext, useEffect, useRef, useState } from "react";
import { apiContext } from "../../../../contexts/apiContext";
import { ObjectState } from "../../taskListView/types/tasklListViewProps";
import ViewContext from "../../../../contexts/viewContext";
import { createValidationKrForm, createValidationPoForm, validationErrorsKrForm, validationErrorsPoForm } from "../../../../helpers/validation/validation";
import { SaveRegistrationCardCommentsProps, SaveRegistrationCardProps } from "../../../../services/registrationCardService/types/registrationCardServiceProps";
import { changeStatusRegistrationCardForm, saveRegistrationCard, saveRegistrationCardComments } from "../../../../services/registrationCardService/registrationCardService";
import { ObjectType, PatternType, toPattern } from "../../../../contexts/types/card";
import { KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes } from "../../../../contexts/krFormContext";
import { canAssignEditorInForm, canAssignVerifierInForm, canHaveEditorAssignedByVerifier, getObjectTypeCodedValue } from "../../../../helpers/processHelper";
import PermissionsContext from "../../../../contexts/permissionsContext";
import AuthContext from "../../../../contexts/authContext";
import { AssignEditorVerifierModalProps } from "../assignEditorVerifierModal/types/assignEditorVerifierModalProps";
import AssignEditorVerifierModal from "../assignEditorVerifierModal/assignEditorVerifierModal";
import { getNavHeadingsKRO, getNavHeadingsKRTZ } from "./navSectionList";
import { setTask } from "../../../../database/indexedDbReadWrite";
import { poFormTypes } from "../../../../contexts/poFormContext";
import { getClosestRefByName, getClosestRefName, prepareAllFields } from "../../../../helpers/form";
import Spinner from "../../../../components/spinner/spinner";
import { ClassNameSpinner } from "../../../../components/spinner/types/spinnerProps";
import { TableContext } from "../../../../contexts/tableContext";

const TitleBar = (props: TitleBarProps) => {
    const api = useContext(apiContext);
    const { setViewType, viewTypes, setViewData, krFormSavePrompt, krFormCallback, setKrFormSavePrompt, savingLocal, setSavingLocal } = useContext(ViewContext);
    const { setCheckboxesTable } = useContext(TableContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const { userRoles } = useContext(AuthContext);
    const [selectedState, setSelectedState] = useState<Option>({});
    const [disableButtons, setDisableButtons] = useState<boolean>(false);
    const [showEditorVerifierModal, setShowEditorVerifierModal] = useState<boolean>(false);
    const [rowsForModal, setRowsForModal] = useState<any[]>([])
    const [isModalEditorVersion, setIsModalEditorVersion] = useState<any>()
    const [assignEditorByVerifier, setAssignEditorByVerifier] = useState<boolean>(false)
    const [gminaTeryt, setGminaTeryt] = useState<string | undefined>(undefined)
    const [scrollPercent, setScrollPercent] = useState<number>(5);
    const [scrollTop, setScrollTop] = useState(0);
    const capturedScrollPosition = useRef<number>(0);
    const capturedRefName = useRef<string | null>(null);
    const [mist, setMist] = useState<boolean>(false);

    useEffect(() => {
        if (props.isKR) {
            var element = getScrollIndicator();
            const onScroll = (e: any) => {
                var percentVisible = (element!.clientHeight / element!.scrollHeight) * 100;
                setScrollPercent(((element!.scrollTop / element!.scrollHeight) * 100) + percentVisible);
                setScrollTop(element!.scrollTop);
            };
            element!.addEventListener("scroll", onScroll);
            return () => element!.removeEventListener("scroll", onScroll);
        }
    }, [scrollTop, props.isKR]);

    useEffect(() => {
        setDisableButtons(savingLocal);
    }, [savingLocal])

    // Navigation select
    const prepareNavSelect = () => {
        var navSelect: Option[] | undefined = [];
        var navItems = props.objectType === ObjectType.KRO ? getNavHeadingsKRO(props.context.landslideAttributes?.wersja === PatternType.P2007) :
            getNavHeadingsKRTZ(props.context.endangeredAreaAttributes?.wersjA_KARTY === PatternType.P2007);
        navItems.forEach(item => {
            navSelect?.push({
                value: item.sectionId,
                name: item.sectionTitle
            })
        })
        return navSelect;
    }

    const navSelectOnChange = (opt: Option) => {
        if (props.toolbar?.executeScroll) props.toolbar?.executeScroll(`heading_${opt.value}`)
    }

    var navigationSelectProps: SelectInputProps = {
        hasInputTags: false,
        options: prepareNavSelect()!,
        placeHolder: "Nawiguj",
        hideLabel: true,
        className: "formToolBarSelectOverwrite",
        pristine: true,
        optionsStyle: {
            fontSize: "smaller"
        },
        onChange: navSelectOnChange,
        disabled: disableButtons
    }

    // Status select
    const prepareSelect = () => {
        var toolBarSelect: Option[] | undefined = [];
        props.objectStatesDetails.forEach((item: any) => {
            if (item.requiredStates.includes(props.currentRow?.attributes?.STAN_OBIEKTU_DOM) || item.requiredStates.length === 0) {
                toolBarSelect?.push({
                    value: item.value,
                    name: item.nameOnForm
                })
            }
        });
        return toolBarSelect
    }

    const toolbarSelectOnChange = (opt: Option) => {
        setSelectedState(opt);
    }

    var statusSelectProps: SelectInputProps = {
        hasInputTags: false,
        options: prepareSelect(),
        placeHolder: "Status dokumentu",
        hideLabel: true,
        className: "formToolBarSelectOverwrite",
        pristine: true,
        optionsStyle: {
            fontSize: "smaller"
        },
        onChange: toolbarSelectOnChange,
        optionItemDots: true,
        colorCodesForDots: props.objectStatesDetails,
        disabled: disableButtons
    }

    // Assign verifier button
    const getBtnProps = (title: string, disabled: boolean, onClick: React.MouseEventHandler<HTMLButtonElement>,
        icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                disabled: disableButtons || disabled,
                className: `${classNameBtn.Btn} ${classNameBtn.Large} formToolBarBtn body-txt-medium`,
                style: {
                    height: "40px"
                }
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: "auto",
                }
            }
        };
    }

    const handleClickAssignEditor = () => {
        var canAssignEdit = canAssignEditorInForm(functionsPermissions.assignEditor.active, userRoles, props.currentRow?.attributes?.STAN_OBIEKTU_DOM);
        if (canAssignEdit) setEditorVerifierModalStates(true);
    }

    const handleClickAssignVerifier = () => {
        var canAssignVerify = canAssignVerifierInForm(functionsPermissions.assignVerifier.active, extendedUserPermissions, userRoles,
            props.currentRow?.attributes?.RODZAJ_OBIEKTU, props.currentRow?.attributes?.STAN_OBIEKTU_DOM, props.currentRow?.attributes?.TERYT, props.currentRow?.attributes?.ZNACZNIK_PROCESU_DOM);
        if (canAssignVerify) setEditorVerifierModalStates(false);
    }

    const setEditorVerifierModalStates = (isEditorVersion: boolean) => {
        var selectedRows: any[] = [];
        var row = props.currentRow?.attributes;
        row.RODZAJ_OBIEKTU_DOM = getObjectTypeCodedValue(props.currentRow?.attributes.RODZAJ_OBIEKTU);
        selectedRows.push(row);
        setRowsForModal(selectedRows);
        setShowEditorVerifierModal(true);

        if (isEditorVersion) {
            setIsModalEditorVersion(true);
            setAssignEditorByVerifier(canHaveEditorAssignedByVerifier(props.currentRow?.attributes?.STAN_OBIEKTU_DOM));
        }
        else {
            setIsModalEditorVersion(false);
            setGminaTeryt(getGminaTeryt(row.RODZAJ_OBIEKTU_DOM));
        }
    }

    const getGminaTeryt = (objType: string) => {
        var teryt: string | undefined = undefined;

        if (objType === "tz") {
            teryt = props.context.endangeredAreaGminy && props.context.endangeredAreaGminy.length > 0 ? props.context.endangeredAreaGminy.find((x: any) => x.kolejnosc === 1).teryt : undefined;
        }
        else if (objType === "osuwisko") {
            teryt = props.context.landslideGminy && props.context.landslideGminy.length > 0 ? props.context.landslideGminy.find((x: any) => x.kolejnosc === 1).teryt : undefined;
        }
        return teryt;
    }

    const onCloseEditorVerifierModal = () => {
        setShowEditorVerifierModal(false);
    }

    const handleSaveFromAssignVerifierModal = () => {
        return new Promise((resolve, reject) => {
            saveForRegistrationCard(getSelectedStateDetails())
                .then((res: any) => {
                    resolve(res);
                })
        })
    }

    const handleSaveCommentsFromAssignEditorModal = () => {
        return new Promise((resolve, reject) => {
            saveCommentsForRegistrationCard()
                .then((res: any) => {
                    resolve(res);
                })
        })
    }

    var assignEditorVerifierModalProps: AssignEditorVerifierModalProps = {
        onClose: onCloseEditorVerifierModal,
        isEditorVersion: isModalEditorVersion,
        rows: rowsForModal,
        assignEditorByVerifier: assignEditorByVerifier,
        triggeredFromForm: true,
        saveForm: handleSaveFromAssignVerifierModal,
        saveFormComments: handleSaveCommentsFromAssignEditorModal,
        teryt: gminaTeryt
    }

    const onSaveStart = () => {
        let element = getScrollIndicator();
        let rect = element?.getBoundingClientRect();
        const offset = rect?.top ? rect.top : 0;

        let top = element?.scrollTop ? element.scrollTop : 0;
        capturedScrollPosition.current = top;

        if (props.formRefs) {
            const name = getClosestRefName(props.formRefs, offset);
            capturedRefName.current = name;
        } else {
            capturedRefName.current = null;
        }
    }

    const onSaveEnd = () => {
        let element = getScrollIndicator();
        setTimeout(() => {
            element?.scrollTo(0, capturedScrollPosition.current);
        }, 1)

        //add delay due to textarea autoresize
        setTimeout(() => {
            if (props.editMode === true && capturedRefName.current !== null && props.formRefs !== undefined) {
                let closest = getClosestRefByName(props.formRefs, capturedRefName.current);
                closest?.scrollIntoView();
            } else {
                element?.scrollTo(0, capturedScrollPosition.current);
            }
            setMist(false);
        }, 1000)
    }

    const getScrollIndicator = () => {
        return document.getElementById("scrollIndicator");
    }

    // Save button
    const handleClickSave = () => {
        onSaveStart();
        setDisableButtons(true);
        setFormSaving(true);
        var selectedStateDetails = getSelectedStateDetails();
        if (props.isKR) {
            if (props.editMode) {
                saveForRegistrationCard(selectedStateDetails);
            } else {
                if (props.local) {
                    if (selectedStateDetails?.nameInDb === ObjectState.Accepted) {
                        return new Promise((resolve) => {
                            setTask(props.context, selectedStateDetails?.nameInDb).then((res) => {
                                resolve(res);
                                notifySuccess({ message: `Zmieniono status na '${selectedStateDetails?.nameOnForm}'` });
                                setViewType(viewTypes.TaskList);
                                stopSaving();
                            }).catch(() => {
                                notifyError({ message: "Zmiana statusu zakończona nie powodzeniem" });
                                stopSaving();
                            });
                        });
                    }
                    else {
                        return new Promise((resolve) => {
                            setTask(props.context).then((res) => {
                                resolve(res);
                                notifySuccess({ message: "Zapisano komentarze do formularza" });
                                if (props.setNewCommentFieldDetails) props.setNewCommentFieldDetails(undefined);
                                stopSaving();
                            }).catch(() => {
                                notifyError({ message: "Próba zapisania komentarzy do formularza zakończona niepowodzeniem" });
                                stopSaving();
                            });
                        });
                    }
                } else {
                    if (selectedStateDetails?.nameInDb === ObjectState.Accepted) {
                        changeStatusRegistrationCardForm(selectedStateDetails?.nameInDb, [props.currentRow.attributes.GLOBALID],
                            api.apiUrl + api.apiVersion, false)
                            .then(() => {
                                notifySuccess({ message: `Zmieniono status na '${selectedStateDetails?.nameOnForm}'` });
                                setViewType(viewTypes.TaskList);
                                setCheckboxesTable([]);
                            })
                    }
                    else saveCommentsForRegistrationCard();
                }
            }
        } else {
            saveForProtocol(selectedStateDetails);
        }
    }

    const stopSaving = () => {
        setDisableButtons(false);
        setFormSaving(false);
        onSaveEnd();
    }

    useEffect(() => {
        if (!props.local) {
            if (krFormSavePrompt) {
                setDisableButtons(true);
                setFormSaving(true);
                const selectedStateDetails = getSelectedStateDetails();
                if (props.isKR) {
                    if (props.editMode) {
                        saveForRegistrationCard(selectedStateDetails).then((response) => {
                            krFormCallback();
                            setKrFormSavePrompt(false);
                        }).catch((error) => {
                            console.log(error);
                            setKrFormSavePrompt(false);
                        });
                    } else {
                        if (selectedStateDetails?.nameInDb === ObjectState.Accepted) {
                            changeStatusRegistrationCardForm(selectedStateDetails?.nameInDb, [props.currentRow.attributes.GLOBALID],
                                api.apiUrl + api.apiVersion, false)
                                .then(() => {
                                    notifySuccess({ message: `Zmieniono status na '${selectedStateDetails?.nameOnForm}'` });
                                    setViewType(viewTypes.TaskList);
                                    setCheckboxesTable([]);
                                    setKrFormSavePrompt(false);
                                    setFormSaving(false);
                                    krFormCallback();
                                }).catch((error) => {
                                    console.log(error);
                                    setKrFormSavePrompt(false);
                                    setFormSaving(false);
                                    krFormCallback();
                                });
                        } else {
                            saveCommentsForRegistrationCard().then((response) => {
                                krFormCallback();
                                setKrFormSavePrompt(false);
                            }).catch((error) => {
                                console.log(error);
                                setKrFormSavePrompt(false);
                            });
                        }
                    }
                } else {
                    saveForProtocol(selectedStateDetails)?.then((response) => {
                        krFormCallback();
                        setKrFormSavePrompt(false);
                    }).catch((error) => {
                        console.log(error);
                        setKrFormSavePrompt(false);
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krFormSavePrompt])

    const getSelectedStateDetails = () => {
        return props.objectStatesDetails.find(item => item.value === selectedState.value);
    }

    const setFormSaving = (formLoading: boolean) => {
        if (props.setSaving) {
            props.setSaving(formLoading);
            if (!formLoading) {
                setMist(true);
            }
        }
    }

    const saveForProtocol = (selectedStateDetails: any) => {
        // Validate form
        let formValidation = createValidationPoForm(props.context);
        let form = { ...props.context, config: { ...props.context.config, Validation: formValidation } };
        form = validationErrorsPoForm(form) as poFormTypes;

        props.setContext(form);

        let cardState = selectedStateDetails?.nameInDb;

        // Only complete form can be accepted
        if (selectedStateDetails?.nameInDb !== undefined && !form.config?.isValid) {
            cardState = undefined;
            notifyError({ message: `Brak możliwości zmiany statusu na '${selectedStateDetails.nameOnForm}' - formularz niekompletny` });
        }

        if (props.local) {
            setTask(form, cardState, form.config?.isValid, true).then((res) => {
                if (form.config?.isValid) {
                    notifySuccess({ message: "Zapisano zmiany w protokole obserwacji - formularz kompletny" });
                    if (cardState === ObjectState.Accepted || cardState === ObjectState.Complete) {
                        setViewType(viewTypes.TaskList);
                    }
                } else {
                    notifyWarn({ message: "Zapisano zmiany w protokole obserwacji - formularz niekompletny" });
                }
                props.setContext(form);
                stopSaving();
            }).catch(() => {
                stopSaving();
                notifyError({ message: "Zapisywanie protokołu obserwacji zakończone niepowodzeniem" });
            })
        }
        else {
            // Save protocol (with state update)
            let saveProtocolProps: SaveProtocolProps = {
                poForm: form,
                state: cardState,
                apiBase: api.apiUrl + api.apiVersion
            }

            return new Promise((resolve) => {
                saveProtocol(saveProtocolProps, form.config?.isValid)
                .then((res: any) => {
                    var response = res.form;
                    resolve(response);
                    if (!res.statusSuccess) {
                        notifyWarn({ message: "Zmiana statusu nie powiodła się" });
                    }
                    if (form.config?.isValid) {
                        notifySuccess({ message: "Zapisano zmiany w protokole obserwacji - formularz kompletny" });
                    }
                    else {
                        notifyWarn({ message: "Zapisano zmiany w protokole obserwacji - formularz niekompletny" });
                    }

                    if (res.statusSuccess && (saveProtocolProps.state === ObjectState.Accepted || saveProtocolProps.state === ObjectState.Complete)) {
                        setViewType(viewTypes.TaskList);
                        if (saveProtocolProps.state === ObjectState.Accepted) {
                            setCheckboxesTable([]);
                        }
                    } else {
                        if (res.statusSuccess && Boolean(saveProtocolProps.state)) {
                            const newRow = { ...props.currentRow, attributes: { ...props.currentRow.attributes, STAN_OBIEKTU_DOM: saveProtocolProps.state } };
                            setViewData(newRow);
                        }
                        response.config = form.config;
                        props.setContext(response);
                        stopSaving();
                    }
                })
                .catch(() => {
                    stopSaving();
                    notifyError({ message: "Zapisywanie protokołu obserwacji zakończone niepowodzeniem" });
                })
            });
        }
    }

    const saveForRegistrationCard = (selectedStateDetails: any) => {
        const objectType = props.currentRow?.attributes?.RODZAJ_OBIEKTU;
        const objectPattern = toPattern(props.currentRow?.attributes?.WZOR);
        // Prepare to save
        let form = structuredClone(props.context) as krFormTypes;
        prepareAllFields(objectType, objectPattern, form);
        // Validate form
        let formValidation = createValidationKrForm(form, objectType, objectPattern);
        form.config = { ...form.config, Validation: formValidation };
        form = validationErrorsKrForm(form, objectType, objectPattern);

        props.setContext(form);

        let cardState = selectedStateDetails?.nameInDb;

        // Only complete form can be accepted or marked as complete       
        if ((cardState === ObjectState.Accepted || cardState === ObjectState.Complete) && !form.config?.isValid) {
            cardState = undefined;
            notifyError({ message: `Brak możliwości zmiany statusu na ${selectedStateDetails?.nameInDb === ObjectState.Accepted ? 'Zatwierdzony' : 'Kompletny'} - formularz niekompletny` });
        }
        if (props.local) {
            setSavingLocal(true);
            return new Promise((resolve) => {
                setTask(form, cardState, form?.config?.isValid ? true : false, false).then((res) => {
                    if (form?.config?.isValid) {
                        notifySuccess({ message: "Zapisano zmiany w karcie rejestracyjnej - formularz kompletny" });
                        if (cardState === ObjectState.Accepted || cardState === ObjectState.Complete) {
                            setViewType(viewTypes.TaskList);
                        }
                    } else {
                        notifyWarn({ message: "Zapisano zmiany w karcie rejestracyjnej - formularz niekompletny" });
                    }
                    resolve(res);
                    setSavingLocal(false);
                    stopSaving();
                }).catch(() => {
                    notifyError({ message: "Zapisywanie karty rejestracyjnej zakończone niepowodzeniem" });
                    setSavingLocal(false);
                    stopSaving();
                });
            });
        } else {
            // Save registration card (with state update)
            let saveRegistrationCardProps: SaveRegistrationCardProps = {
                form: form,
                objectType: objectType ? objectType : ObjectType.KRO,
                state: cardState,
                apiBase: api.apiUrl + api.apiVersion,
                validationStatus: form?.config?.isValid ? "pozytywna" : "negatywna"
            }

            return new Promise((resolve) => {
                saveRegistrationCard(saveRegistrationCardProps)
                    .then((res: any) => {
                        var response = res.form;
                        if (!res.statusSuccess) {
                            notifyWarn({ message: "Zmiana statusu nie powiodła się" });
                        }
                        if (form?.config?.isValid) {
                            notifySuccess({ message: "Zapisano zmiany w karcie rejestracyjnej - formularz kompletny" });
                        } else {
                            notifyWarn({ message: "Zapisano zmiany w karcie rejestracyjnej - formularz niekompletny" });
                        }

                        if (res.statusSuccess && (saveRegistrationCardProps.state === ObjectState.Accepted || saveRegistrationCardProps.state === ObjectState.Complete)) {
                            setViewType(viewTypes.TaskList);
                             if (saveRegistrationCardProps.state === ObjectState.Accepted) {
                                setCheckboxesTable([]);
                            }
                        } else {
                            if (res.statusSuccess && Boolean(saveRegistrationCardProps.state)) {
                                const newRow = { ...props.currentRow, attributes: { ...props.currentRow.attributes, STAN_OBIEKTU_DOM: saveRegistrationCardProps.state } };
                                setViewData({ row: newRow, editMode: props.editMode });
                            }
                            response.config = form.config;
                            response.dicts = form.dicts;
                            response.dictionaries = form.dictionaries;
                            if (saveRegistrationCardProps.objectType === ObjectType.KRO) {
                                response.landslideGminy = (form as KrLandslideFormTypes)?.landslideGminy;
                            } else {
                                response.endangeredAreaGminy = (form as KrEndangeredAreaFormTypes)?.endangeredAreaGminy;
                            }
                            if (response.formComments && props.prepareComments) response.formComments = props.prepareComments(response.formComments);
                            props.setContext(response);
                            stopSaving();
                        }
                        resolve(response);
                    })
                    .catch(() => {
                        notifyError({ message: "Zapisywanie karty rejestracyjnej zakończone niepowodzeniem" });
                        stopSaving();
                    })
            })
        }
    }

    const saveCommentsForRegistrationCard = () => {
        var saveRegistrationCardCommentsProps: SaveRegistrationCardCommentsProps = {
            comments: props.context.formComments,
            waitingRoomId: props.currentRow.attributes.ID,
            apiBase: api.apiUrl + api.apiVersion
        }

        return new Promise((resolve) => {
            saveRegistrationCardComments(saveRegistrationCardCommentsProps)
                .then((res: any) => {
                    notifySuccess({ message: "Zapisano komentarze do formularza" });
                    if (props.setNewCommentFieldDetails) props.setNewCommentFieldDetails(undefined);
                    stopSaving();
                    resolve(res);
                })
                .catch(() => {
                    notifyError({ message: "Próba zapisania komentarzy do formularza zakończona niepowodzeniem" });
                    stopSaving();
                })
        })
    }

    const getTitle = () => {
        if (!props.isKR && props.context.protocolAttributes?.datA_OBS) {
            return `${props.title} ${new Date(props.context.protocolAttributes?.datA_OBS).toLocaleDateString()}`;
        }
        else { return props.title; }
    }

    return (
        <>
        {mist && props.saving !== true && <Spinner isMist={true} spinnerClass={ClassNameSpinner.Big} />}
        <div>
            <div className={props.toolbar?.isVisible ? "titleBarWithToolbar" : "titleBar"}>
                <p className="body-txt-XL">{getTitle()}</p>
                {!props.loading && props.toolbar?.isVisible &&
                    <div className="formToolBar">
                        {props.isKR && <SelectInput {...navigationSelectProps} />}
                        <SelectInput {...statusSelectProps} />
                        {props.toolbar.isVerifyBtn && !props.local ?
                            <ButtonField {...getBtnProps(
                                "Przypisz Weryfikatora",
                                !props.toolbar.assignVerifier,
                                () => { handleClickAssignVerifier() },
                                accountCircle)
                            }></ButtonField>
                            : undefined}
                        {props.toolbar.isEditorBtn && !props.local &&
                            <ButtonField {...getBtnProps(
                                "Przypisz Edytora",
                                !props.toolbar.assignEditor,
                                () => { handleClickAssignEditor() },
                                accountCircle)
                            }></ButtonField>
                        }
                        <ButtonField {...getBtnProps(
                            "Zapisz",
                            false,
                            () => { handleClickSave() })
                        }></ButtonField>
                        {props.toolbar.mapBtn &&
                            <div style={{ width: "48px" }}></div>
                        }
                    </div>
                }
            </div>
            {(!props.loading && !props.saving) && props.isKR && <div className="scrollIndicatorWrapper"><div style={{ width: `${scrollPercent}%` }}></div></div>}
            {showEditorVerifierModal && <AssignEditorVerifierModal {...assignEditorVerifierModalProps} />}
        </div>
        </>
    )

}

export default TitleBar;